import React from 'react';

import SocialLink from './Social';
import TelegramIcon from '../icons/Telegram';

import classes from '../Footer.scss';

export default function TelegramLink(props) {
  return (
    <SocialLink
      href  = "https://t.me/CityAds_Media"
      title = "Telegram"
      {...props}
    >
      <TelegramIcon className={classes.socialIcon} />
    </SocialLink>
  );
}